import { createAction } from '@ngrx/store';

export const Login = createAction('[Authentication] - Login');
export const LoginSuccess = createAction('[Authentication] - Login Success');
export const LoginFail = createAction('[Authentication] - Login Fail');

export const Logout = createAction('[Authentication] - Logout');
export const LogoutSuccess = createAction('[Authentication] - Logout Success');
export const LogoutFail = createAction('[Authentication] - Logout Fail');
